<style>

</style>

<template>
    <div class="main-content">
        <section class="section">
            <div class="section-header">
                <h1>Print Invoice</h1>
            </div>
            <div class="section-body">
                <h2 class="section-title">Nomor Transaksi : {{ tipe_transaksi }}</h2>
                <div class="row mx-auto">
                    <div id="printMe" class="col-12">
                        <div class="card">
                            <div class="card-header">
                                <h4>PT. EFI</h4>
                            </div>
                            <div class="card-body">
                                <div class="table-responsive">
                                    <table class="table" style="border:none;">
                                        <tbody>
                                            <tr>
                                                <th style="width:20%;border:none;">
                                                    Customer
                                                </th>
                                                <td style="border:none;">
                                                    {{ transaksiDetail.detail.display_name }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th style="border:none;">
                                                    Email  
                                                </th>
                                                <td style="border:none;">
                                                    {{ transaksiDetail.detail.email }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th style="border:none;">
                                                    Alamat Customer  
                                                </th>
                                                <td style="border:none;">
                                                    ({{ transaksiDetail.detail.alamat }})
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                
                                <div class="table-responsive">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>No. </th>
                                                <th>Produk</th>
                                                <th>Kuantitas</th>
                                                <th>Harga Satuan</th>
                                                <th>Jumlah</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(data,index) in transaksiDetail.produkList" v-bind:key="data.id_produk">
                                            <td>
                                                {{ index+1 }}
                                            </td>
                                            <td>
                                                {{ data.nama_produk }}
                                            </td>
                                            <td>
                                                {{ data.qty }} {{ data.nama_satuan }}
                                            </td>
                                            <td>
                                                Rp. {{ currencyFormat(data.harga_satuan) }}
                                            </td>
                                            <td>
                                                Rp. {{ currencyFormat(data.harga_total) }}
                                            </td>
                                        </tr>
                                        </tbody>
                                        <tr>
                                            <th colspan="4" style="text-align:right">Sub Total</th>
                                            <th>
                                                Rp. {{ currencyFormat(transaksiDetail.detail.total_harga) }}
                                            </th>
                                        </tr>
                                        <tr>
                                            <th colspan="4" style="text-align:right">Dibayar</th>
                                            <th>
                                                Rp. {{ currencyFormat(transaksiDetail.detail.dibayar) }}
                                            </th>
                                        </tr>
                                        <tr>
                                            <th style="text-align:right" colspan="4">Total Tagihan</th>
                                            <th>Rp. {{ currencyFormat(transaksiDetail.detail.outstanding) }}</th>
                                        </tr>
                                        <tr>
                                            <td colspan="4" style="text-align:right;padding-top:10%;">
                                                &nbsp;
                                            </td>
                                            <td>
                                                Tertanda
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div class="col-12 text-center">
                        <button @click="printInvoice()" class="btn btn-success"> <i class="fas fa-file"></i> Print Invoice</button>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import Vue from 'vue';
import VueHtmlToPaper from 'vue-html-to-paper';


const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css',
    'https://use.fontawesome.com/releases/v5.7.2/css/all.css'
  ]
}

Vue.use(VueHtmlToPaper, options);

export default {
    data() {
        return {
            transaksiDetail : {
                detail : {
                    nomor_transaksi : '',
                }
            },
            id_transaksi : '',
            tipe_transaksi : '',
            jenis_transaksi : '',
            url : '',
            jenis_transaksi : 'pembelian',
            setPengiriman : false,
            setPenerimaan : false,
            tanggal_pengiriman: '',
            tanggal_terima: '',
            produkDiterima : [],
        }
    },
    mounted() {
        this.id_transaksi = this.$route.params.id_transaksi;
        this.init();
    },
    methods: {
        init: function() {
            this.$http.post("Transaksi/getTransaksiDetail/"+this.id_transaksi).then(result => {
			    if(result.data.code == '00') {
                    alert('failed get Detail')
                }
                else {
                    this.transaksiDetail = result.data.detail
                    this.tipe_transaksi = result.data.detail.detail.tipe_transaksi+" #"+result.data.detail.detail.nomor_transaksi
                    this.url = result.data.detail.detail.tipe_transaksi+"-"+this.jenis_transaksi
                    if(this.url == 'pemesanan-pembelian'){
                        this.setPengiriman = true
                    }else if(this.url == 'pengiriman-pembelian'){
                        this.setPenerimaan = true
                    }else if(this.url == 'faktur-pembelian') {

                    }
                }
			}, error => {
				console.log('gk ok')
				context.errors = errors;
            });
        },
        currencyFormat: function(val){
            return this.$parent.currencyFormat(val)
        },
        printInvoice: function() {
            this.$htmlToPaper('printMe', () => {
                console.log('Printing done or got cancelled!');
            });
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/pembelian/PrintSuratJalan.vue